/* wsapi3-apps v1.0 */
/* Deploy Version 2026-09-17 17:24:08 */
/* Registro de "apps nativos substituídos pelo tema". Precisa carregar com
   etapa:"*" e ANTES do bloco de apps da API dentro do GERAL.js — a ordem de
   concatenação em local-layout.service.ts (buildAndWriteAssets) garante isso:
   módulos padrão (passo 1) entram no array antes dos apps vindos de
   /store/layout/apps (passo 2), mesmo grupo GERAL, mesmo <script>, então isso
   aqui já roda antes do app nativo checar a flag.

   Cada chave diz "o tema já reimplementou esse app, não execute a versão
   nativa". O app nativo (mantido no banco/plataforma) precisa checar essa
   flag antes de rodar sua própria lógica. */
window.WsApi3Apps = window.WsApi3Apps || {};
window.WsApi3Apps.freteGratis = true;

/* Só a parte do ProductRecomend (app "suggestion-slider") que tenta injetar
   no cart-drawer — a parte que injeta na página /carrinho (etapasObj.carrinho)
   continua nativa, não temos substituto pra ela ainda (ver Fase 1 do redesign
   do checkout-cart). Flag específica, não a mesma chave genérica, porque o
   app nativo é usado em dois contextos e só um foi substituído. */
window.WsApi3Apps.productRecomendDrawer = true;

/* ===========================================
   MODULE: CHECKOUT SUGGESTION SLIDER (07/08/26)
   Reimplementação local do "Aproveite e leve também" (recomendados) só na
   página /carrinho — o drawer já é coberto pelo flag productRecomendDrawer
   acima + wsapi3-cart-drawer-rules._renderSuggestions().

   Detecção: o app nativo passa a expor `let wsAppRecomend = true;` no script
   injetado quando o app está ativo na loja. Isso só diz SE devemos renderizar
   — não existe (ainda) flag nativo equivalente ao productRecomendDrawer pra
   suprimir o /carrinho do lado nativo.

   NEUTRALIZAÇÃO do app nativo (a única forma confiável de evitar duplicação):
   o create() nativo (etapasObj.carrinho) faz
   `document.querySelectorAll("[cart-suggestion-slider]")` e reescreve
   incondicionalmente TODO elemento com esse atributo — inclusive o que a
   gente já criou — sem checar quem o criou. A checagem de idempotência dele
   (`!existAncor.querySelector("[cart-suggestion-slider]")`) só evita criar um
   SEGUNDO elemento, não impede o create() de sobrescrever o conteúdo do que
   já existe. Como o get() nativo primeiro faz
   `await ApiWS.Calls.listProducts.suggestion()` (uma chamada de API), nosso
   slider nascia certo e, ~1s depois — quando essa promise nativa resolvia —
   era reescrito com o layout dele (perView 3.4). Só ganhar a corrida de
   criação da âncora não resolve; por isso interceptamos wsMain.createModule
   e neutralizamos os métodos do módulo nativo "suggestion-slider" assim que
   ele tenta se registrar (this.modules[obj.name] = obj não tem nenhuma
   proteção contra nome duplicado/patch). */
/* setTimeout(fn, 0) em vez de IIFE imediata: "wsMain" (const wsMain = new
   wsMainjs()) só é instanciado mais adiante no mesmo bundle concatenado
   (GERAL.js) — acessar wsMain de forma síncrona aqui no topo do arquivo
   estoura "Cannot access 'wsMain' before initialization" (TDZ) e trava a
   aplicação inteira. Um setTimeout(0) roda só depois que todo o script
   síncrono (incluindo a instanciação do wsMain) já terminou — e ainda assim
   bem antes do setTimeout(..., 3000) nativo. */
setTimeout(function () {
    if (wsMain.__suggestionSliderPatched) return;
    wsMain.__suggestionSliderPatched = true;
    const originalCreateModule = wsMain.createModule.bind(wsMain);
    wsMain.createModule = function (obj) {
        if (obj && obj.name === "suggestion-slider") {
            const noop = () => false;
            ["get", "create", "update", "clear", "watching"].forEach(fn => {
                if (typeof obj[fn] === "function") obj[fn] = noop;
            });
        }
        return originalCreateModule(obj);
    };
}, 0);

var WS_SUGGESTION_SLIDER_DEBUG = false;
function wsSuggestionLog() {
    if (!WS_SUGGESTION_SLIDER_DEBUG) return;
    try { console.log.apply(console, arguments); } catch (_) { }
}

function wsSuggestionAfterBuy() {
    ApiWS.Calls.cartView().then(function (fresh) {
        if (fresh && fresh.products !== undefined) {
            window.cartJson = fresh;
            try { wsMain.modules['checkout-cart2'].create(fresh); } catch (e) { }
        }
    }).catch(function (e) { console.error('[checkout-suggestion] afterBuy:', e); });
}

setTimeout(function () {
    wsMain.createModule({
        name: "checkout-suggestion",
        function: "get",

        subFunctions: {
            waitForNativeFlag(attempt) {
                attempt = attempt || 0;
                return new Promise(resolve => {
                    if (typeof wsAppRecomend !== 'undefined') { resolve(!!wsAppRecomend); return; }
                    if (attempt >= 6) { resolve(false); return; }
                    setTimeout(() => {
                        wsMain.modules["checkout-suggestion"].subFunctions.waitForNativeFlag(attempt + 1).then(resolve);
                    }, 500);
                });
            },

            createAncor() {
                const holder = document.querySelector('#ws-carrinhoNovo [ws-cart-app="app-suggestion"]');
                if (!holder) return null;
                // Checa os dois atributos: o nosso (ws-suggestion-slider) e o nativo
                // (cart-suggestion-slider, só por segurança — o JS nativo já está
                // neutralizado via patch em wsMain.createModule, mas não custa nada
                // continuar defensivo aqui).
                if (holder.querySelector('[ws-suggestion-slider], [cart-suggestion-slider]')) return null;

                const targetType = window.innerWidth < 1000 ? "checkoutMobile" : "checkout";
                // Atributo próprio (NÃO "cart-suggestion-slider") de propósito: esse é
                // o nome que o app nativo usa, e o CSS injetado por ele (separado do
                // JS, que já neutralizamos) também estiliza esse seletor — inclusive
                // com um padding vertical de 5rem que ficava vazando pro nosso card
                // por causa da cascata (mesma especificidade, CSS nativo concatenado
                // depois do nosso). Usando um atributo só nosso, nenhuma regra CSS
                // nativa consegue mais alcançar esse elemento.
                const slider = wsMain.tools.createElm({ type: "div", attrs: { "ws-suggestion-slider": targetType } });
                holder.append(slider);
                return slider;
            },

            createProds(prod) {
                const shopId = document.querySelector('#HD_LV_ID')?.value || '';
                const buttonLink = `javascript:void(wsFuncBtBuyOnList('${shopId}', '${prod.id}', 'wsSuggestionAfterBuy()'))`;

                const prodPrice = prod?.precos?.preco_promocao
                    ? wsMain.data.treatPrice(prod.precos.preco_promocao)
                    : wsMain.data.treatPrice(prod.precos.preco);

                let prodImage = `<span data-wsjs-icon="noimage"></span>`;
                let prodClass = `suggestion__image-link whithout-image`;
                if (prod.fotos && prod.fotos.length) {
                    prodClass = `suggestion__image-link`;
                    prodImage = `<img src="${prod.fotos[0]}" alt="${(prod.nome || '').replace(/"/g, '&quot;')}">`;
                }

                return wsMain.tools.createElm({
                    type: "div",
                    attrs: { class: "suggestion-prod" },
                    innerHTML: `
                        <div class="suggestion__image-container">
                            <a class="${prodClass}" href="${prod.links?.ver_produto || '#'}">${prodImage}</a>
                        </div>
                        <div class="suggestion__infos-container">
                            <p class="infos-container__name">${prod.nome}</p>
                            <p class="infos-container__price">${prodPrice}</p>
                            <a class="suggestion__btn" href="${buttonLink}">Adicionar</a>
                        </div>`,
                });
            },
        },

        getCartSig() {
            const cart = window.cartJson;
            return cart ? `${Array.isArray(cart.products) ? cart.products.length : 0}|${cart.total || ''}` : '';
        },

        async get() {
            try {
                if (!document.querySelector('#ws-carrinhoNovo [ws-cart-app="app-suggestion"]')) return false;

                const enabled = await wsMain.modules["checkout-suggestion"].subFunctions.waitForNativeFlag();
                wsSuggestionLog("[checkout-suggestion] get() | wsAppRecomend habilitado:", enabled);
                if (!enabled) return false;

                const anchor = wsMain.modules["checkout-suggestion"].subFunctions.createAncor();
                if (!anchor) return false; // já existe uma âncora (nossa ou nativa) — não duplica

                const prodsArr = await ApiWS.Calls.listProducts.suggestion();
                if (!Array.isArray(prodsArr) || !prodsArr.length) { anchor.remove(); return false; }

                wsMain.modules["checkout-suggestion"].create(anchor, prodsArr);
                // Semeia com a assinatura ATUAL do carrinho — sem isso, o primeiro
                // tick do watching() sempre bate diferente de "" e força um
                // re-render ~1,5s depois mesmo sem nenhuma mudança real no carrinho
                // (causava o "renderiza de um jeito e troca sozinho" reportado).
                wsMain.modules["checkout-suggestion"].watching(anchor, wsMain.modules["checkout-suggestion"].getCartSig());
                return true;
            } catch (error) { wsSuggestionLog("[checkout-suggestion] get() | error:", error); return false; }
        },

        create(anchor, prodsArr) {
            try {
                anchor.innerHTML = "";
                anchor.append(wsMain.tools.createElm({ type: "div", attrs: { class: "container" } }));
                const container = anchor.querySelector(".container");
                container.append(
                    wsMain.tools.createElm({ type: "div", attrs: { class: "suggestion__title" }, innerHTML: `<h2>Aproveite e leve também</h2>` }),
                    wsMain.tools.createElm({ type: "div", attrs: { class: "suggestion__sliderProds" } })
                );

                const sliderContainer = anchor.querySelector(".suggestion__sliderProds");
                const targetType = anchor.getAttribute("ws-suggestion-slider");
                const perView = prodsArr.length <= 2 ? 2 : 2.5;
                const dataWsjsSlide = targetType === "checkoutMobile"
                    ? `slides.perView:1.5;slides.spacing:12;dots:false;arrows:false;loop:false;dotsType:group;`
                    : `slides.perView:${perView};slides.spacing:20;dots:false;loop:false;dotsType:group;`;
                anchor.setAttribute("data-wsjs-slide", dataWsjsSlide);

                prodsArr.forEach(prod => {
                    const elm = wsMain.modules["checkout-suggestion"].subFunctions.createProds(prod);
                    if (elm) sliderContainer.append(elm);
                });

                const sliderOptions = wsMain.tools.getWsData(anchor, "slide");
                const [sliderVrf, slider] = wsMain.tools.createSlide(sliderContainer, sliderOptions);
                if (sliderVrf) slider.update();

                return true;
            } catch (error) { wsSuggestionLog("[checkout-suggestion] create() | error:", error); return false; }
        },

        async watching(anchor, lastSig) {
            try {
                await new Promise(r => setTimeout(r, 1500));
                if (!anchor?.isConnected) return; // âncora removida (ex: navegou pra outra página)

                const sig = wsMain.modules["checkout-suggestion"].getCartSig();

                if (sig && sig !== lastSig) {
                    const prodsArr = await ApiWS.Calls.listProducts.suggestion();
                    if (Array.isArray(prodsArr) && prodsArr.length) {
                        wsMain.modules["checkout-suggestion"].create(anchor, prodsArr);
                    } else if (Array.isArray(prodsArr)) {
                        anchor.innerHTML = "";
                    }
                }

                wsMain.modules["checkout-suggestion"].watching(anchor, sig || lastSig);
            } catch (error) { wsSuggestionLog("[checkout-suggestion] watching() | error:", error); }
        },
    });

    wsMain.modules["checkout-suggestion"].get();
}, 3000);
